export const SET_UKG_EMPLOYEES = 'SET_UKG_EMPLOYEES';
export const SET_NCNS_REQUESTS = 'SET_NCNS_REQUESTS';
export const SET_NCNS_DETAILS = 'SET_NCNS_DETAILS';

export const setUkgEmployees = (payload: any) => {
  return {
    type: SET_UKG_EMPLOYEES,
    payload,
  };
};

export const setNCNSRequests = (requests: any) => {
  return {
    type: SET_NCNS_REQUESTS,
    payload: requests,
  };
};

export const setNCNSDetails = (payload: any) => {
  return {
    type: SET_NCNS_DETAILS,
    payload,
  };
};
